export const getAddOnsTotal = (masterContract, isGuestView) => {
  const masterCalculations = (masterContract || {}).calculations;
  const addOnsTotal = masterCalculations?.add_ons?.amount || 0;
  const addOnsTotalHost =
    (!isGuestView && masterCalculations?.host_add_ons_summary?.amount) ||
    addOnsTotal;

  return isGuestView ? addOnsTotal : addOnsTotalHost;
};
